<template>
  <span class="svg-icon">
    <svg-view
      v-if="name === 'view'"
      :shadow="shadow"
      :color="color"
    />
    <svg-like
      v-if="name === 'like'"
      :shadow="shadow"
      :color="color"
    />
    <svg-comment
      v-else-if="name === 'comment'"
      :shadow="shadow"
      :color="color"
    />
    <svg-information
      v-else-if="name === 'information'"
      :color="color"
    />
    <svg-pano-select
      v-else-if="name === 'panoSelect'"
      :color="color"
    />
    <svg-floorplan
      v-else-if="name === 'floorplan'"
      :color="color"
    />
    <svg-location
      v-else-if="name === 'location'"
      :color="color"
    />
    <svg-share
      v-else-if="name === 'share'"
      :color="color"
    />
    <svg-music
      v-else-if="name === 'music'"
      :color="color"
    />
    <svg-fullscreen
      v-else-if="name === 'fullscreen'"
      :color="color"
    />
    <svg-gyro
      v-else-if="name === 'gyro'"
      :color="color"
    />
    <svg-website
      v-else-if="name === 'website'"
      :color="color"
    />
    <svg-vrmode
      v-else-if="name === 'vrmode'"
      :color="color"
    />
    <svg-show-mobile-menu
      v-else-if="name === 'showMobileMenu'"
      :color="color"
    />
    <svg-close-mobile-menu
      v-else-if="name === 'closeMobileMenu'"
      :color="color"
    />
    <svg-close
      v-else-if="name === 'close'"
      :color="color"
    />
    <svg-search
      v-else-if="name === 'search'"
      :color="color"
    />
    <svg-back-to
      v-else-if="name === 'backTo'"
      :color="color"
    />
    <svg-play
      v-else-if="name === 'play'"
      :color="color"
    />
    <svg-pause
      v-else-if="name === 'pause'"
      :color="color"
    />
    <svg-record
      v-else-if="name === 'record'"
      :color="color"
    />
    <svg-stop
      v-else-if="name === 'stop'"
      :color="color"
    />
    <svg-pilot
      v-else-if="name === 'pilot'"
      :color="color"
    />
    <svg-map
      v-else-if="name === 'map'"
      :color="color"
    />
    <svg-home
      v-else-if="name === 'home'"
      :color="color"
    />
    <svg-expoHall
      v-else-if="name === 'expohall'"
      :color="color"
    />
    <svg-agenda
      v-else-if="name === 'agenda'"
      :color="color"
    />
    <svg-auditorium
      v-else-if="name === 'auditorium'"
      :color="color"
    />
    <svg-networking
      v-else-if="name === 'networking'"
      :color="color"
    />
    <svg-sponsor
      v-else-if="name === 'sponsor'"
      :color="color"
    />
    <svg-visitor
      v-else-if="name === 'visitor'"
      :color="color"
    />
    <svg-vector-up
      v-else-if="name === 'vectorup'"
      :color="color"
    />
    <svg-vector-down
      v-else-if="name === 'vectordown'"
      :color="color"
    />
  </span>
</template>

<script>
import SvgClose from './img/SvgClose'
import SvgCloseMobileMenu from './img/SvgCloseMobileMenu'
import SvgComment from './img/SvgComment'
import SvgFloorplan from './img/SvgFloorplan'
import SvgFullscreen from './img/SvgFullscreen'
import SvgGyro from './img/SvgGyro'
import SvgWebsite from './img/SvgWebsite'
import SvgInformation from './img/SvgInformation'
import SvgLike from './img/SvgLike'
import SvgLocation from './img/SvgLocation'
import SvgMusic from './img/SvgMusic'
import SvgPanoSelect from './img/SvgPanoSelect'
import SvgShare from './img/SvgShare'
import SvgShowMobileMenu from './img/SvgShowMobileMenu'
import SvgVrmode from './img/SvgVrmode'
import SvgView from './img/SvgView'
import SvgSearch from './img/SvgSearch'
import SvgBackTo from './img/SvgBackTo'
import SvgPlay from './img/SvgPlay'
import SvgPause from './img/SvgPause'
import SvgRecord from './img/SvgRecord'
import SvgStop from './img/SvgStop'
import SvgPilot from './img/SvgPilot'
import SvgMap from './img/SvgMap'
import SvgHome from './img/SvgHome'
import SvgExpoHall from './img/SvgExpoHall'
import SvgAgenda from './img/SvgAgenda'
import SvgAuditorium from './img/SvgAuditorium'
import SvgNetworking from './img/SvgNetworking'
import SvgSponsor from './img/SvgSponsor'
import SvgVisitor from './img/SvgVisitor'
import SvgVectorUp from './img/SvgVectorUp'
import SvgVectorDown from './img/SvgVectorDown'

export default {
  name: 'SvgIcon',
  components: {
    SvgClose,
    SvgCloseMobileMenu,
    SvgComment,
    SvgFloorplan,
    SvgFullscreen,
    SvgGyro,
    SvgWebsite,
    SvgInformation,
    SvgLike,
    SvgLocation,
    SvgMusic,
    SvgPanoSelect,
    SvgShare,
    SvgShowMobileMenu,
    SvgVrmode,
    SvgView,
    SvgSearch,
    SvgBackTo,
    SvgPlay,
    SvgPause,
    SvgRecord,
    SvgStop,
    SvgPilot,
    SvgMap,
    SvgHome,
    SvgExpoHall,
    SvgAgenda,
    SvgAuditorium,
    SvgNetworking,
    SvgSponsor,
    SvgVisitor,
    SvgVectorUp,
    SvgVectorDown
  },

  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    color: {
      type: String,
      default () {
        return '#fff'
      }
    },
    shadow: {
      type: Boolean,
      default () {
        return false
      }
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/common/extends'

.svg-icon {
  @extend .flex-center
}
</style>
